import React, { FC } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom';
import Page404 from '../screens/Page404';
import DashboardContainer from '../screens/dashboard/DashboardContainer';
import Auth from 'screens/Auth';

const AppNavigation: FC = () => {
    return (
        <Switch>
            <Route path='/' exact component={Auth} />
            <Route path='/dashboard' component={DashboardContainer} />
            <Route path='/*' exact component={Page404} />
        </Switch>
    )
}

export default withRouter(AppNavigation);